import { motion } from "framer-motion";

const RESULTS = [
  {
    car: "Audi RS3 8V",
    stage: "Stage 2",
    bhpBefore: 362,
    bhpAfter: 478,
    torqueBefore: 465,
    torqueAfter: 610,
    image:
      "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxzcG9ydHMlMjBjYXIlMjBkYXJrJTIwc3R1ZGlvJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzg0MTg1NTM0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    car: "BMW M140i F20",
    stage: "Stage 1+",
    bhpBefore: 335,
    bhpAfter: 421,
    torqueBefore: 500,
    torqueAfter: 640,
    image:
      "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBjYXIlMjBkYXJrJTIwc3R1ZGlvJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzg0MTg1NTM0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    car: "VW Golf R Mk7.5",
    stage: "Stage 2 + DSG",
    bhpBefore: 306,
    bhpAfter: 402,
    torqueBefore: 400,
    torqueAfter: 540,
    image:
      "https://images.unsplash.com/photo-1782404183373-aefa860ae6b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxjYXIlMjBlbmdpbmUlMjBkZXRhaWwlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc4NDE4NTUzNHww&ixlib=rb-4.1.0&q=85",
  },
];

export default function DynoResults() {
  return (
    <section
      id="results"
      className="relative bg-carbon py-24 md:py-32 px-6 md:px-10 border-t border-white/10"
      data-testid="results-section"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-volt">
              ◉ Real Results
            </p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.9] tracking-tighter">
              Before. After. <br />
              <span className="text-white/40">Verified.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {RESULTS.map((r, i) => (
            <motion.div
              key={r.car}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.76, 0, 0.24, 1] }}
              className="col-span-12 md:col-span-6 lg:col-span-4 group"
              data-testid={`result-card-${i}`}
            >
              <div className="relative overflow-hidden clipped-frame h-[280px] md:h-[340px] mb-6">
                <img
                  src={r.image}
                  alt={`${r.car} ${r.stage} remap — before and after in Nottingham & Derby`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover scale-[1.05] group-hover:scale-[1.12] transition-transform duration-[1200ms] ease-[cubic-bezier(0.76,0,0.24,1)]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-widest bg-volt text-black px-2 py-1">
                  {r.stage}
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="font-display uppercase text-xl md:text-2xl leading-tight">
                    {r.car}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6 border-t border-white/10 pt-6">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-2">Power</div>
                  <div className="font-mono text-white/50 text-sm">
                    {r.bhpBefore} → <span className="text-volt font-medium text-lg">{r.bhpAfter}</span> <span className="text-xs">bhp</span>
                  </div>
                </div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-2">Torque</div>
                  <div className="font-mono text-white/50 text-sm">
                    {r.torqueBefore} → <span className="text-volt font-medium text-lg">{r.torqueAfter}</span> <span className="text-xs">Nm</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
